<template>
    <div>
        <div v-if="active === 2 && $common.is_weixn()">
            <Wp_open_by_browser></Wp_open_by_browser>
        </div>
        <div v-else>

            <van-sticky>
                <Wp_user_banner ref="wp_user_banner" v-on:reload="reloadPage"></Wp_user_banner>
            </van-sticky>

            <van-cell-group style="margin-top: 10px">
                <van-cell title="提款" is-link @click="payDataDetail"/>
                <van-cell title="手机号[修改/绑定]" :label="formatPhoneNumber(phoneNumber)" is-link @click="updatePassword"/>
                <van-cell title="邀请超级会员" label="建议微信中打开效果更佳" is-link @click="invite"></van-cell>
                <van-cell title="前往小程序" label="可通过会员编号和密码登录小程序" is-link @click="showMiniQrImg"></van-cell>
                <van-cell v-if="!$common.gloabl_wx_openid" title="修改密码" is-link @click="modifyPassword"/>
                <van-cell title="建群帮助" is-link @click="$goto('request')"/>
                <!--            <van-cell title="常见问题" is-link @click="$goto('question_answer')"/>-->
                <van-cell v-if="phoneNumber && can_change_account" title="切换账号" is-link @click="$goto('change_account')"/>
                <van-cell v-if="robot_list && robot_list.length > 0"  title="助理工具" is-link @click="$goto('robot_tools')"/>
                <!--            <van-cell title="测试" is-link @click="postWxUserData('小南', 'http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJGADL53L357vtThl1lBr2x3UWoMTDcsicpJDpq5PW9CD1KMSdPE56ib5WIOKZRQUv1icCaSqPEY4u9Q/132')"/>-->
                <van-cell v-if="$common.canShowTaobao()"  title="[淘宝&饿了么]授权" is-link @click="clickToAuthTb"/>
                <!--            <Wp_robot_public_on_off_model></Wp_robot_public_on_off_model>-->
            </van-cell-group>

            <Wp_invite_by_qrcode :inviteId="invite_id" :activeShow="show_share_pop"
                                 :wxUserInfo="wx_user_info" :newLink="qrcodeLink" useTo="h5">
            </Wp_invite_by_qrcode>

            <van-popup v-model="showLoading">

                <van-loading type="spinner" color="#1989fa" vertical
                             style="padding: 30px;">
                    <div slot="default" style="text-align: center" v-html="loadingText"></div>
                </van-loading>

            </van-popup>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import Wp_user_banner from "../custom/Wp_user_banner";
    import Wp_invite_by_qrcode from "../custom/Wp_invite_by_qrcode";

    import {Toast, Dialog, ImagePreview} from 'vant';
    import common from "../../js/common";
    import Wp_robot_public_on_off_model from "../custom/Wp_robot_public_on_off_model";
    import Wp_open_by_browser from "../custom/Wp_open_by_browser";
    Vue.use(Toast)

    export default {
        name: "Wp_jd_my",
        components: {Wp_open_by_browser, Wp_robot_public_on_off_model, Wp_invite_by_qrcode, Wp_user_banner},
        data() {
            return {
                active: 0,
                invite_id: "df98s0f",
                show_share_pop: "",
                wx_user_info: null,
                invite_status: true,
                test: '',

                phoneNumber: this.$store.state.userPhone,

                qrcodeLink: "",

                showLoading: false,
                loadingText: "加载中请稍后",

                can_change_account: false,

                url_2: "",
                robot_list: [],
            }
        },


        created() {
            this.initActive();
            this.$getRobotList(list=>{
                this.robot_list = list;
            });

            this.getAccountListByPhone();

            // this.$getQrUrl({}, response=>{
            //     this.$log(response)
            // })


            if (this.$common.gloabl_wx_openid) {
                this.wx_user_info = this.$common.gloabl_wx_mini_user_info;
                // this.$log(this.wx_user_info)
            } else {
                if (this.$common.is_weixn() && !this.isTest() && this.active !== 2) {
                // if (this.$common.is_weixn()) {
                    if (this.$common.wx_user_info && this.$common.wx_user_info.openid) {
                        this.wx_user_info = this.$common.wx_user_info;
                    } else {
                        this.initWxUserInfo(response => {
                            this.wx_user_info = response;
                            //将微信用户相关数据存入临时缓存
                            this.$common.wx_user_info = response;

                            if (response.openid && typeof (response.openid) !== "undefined") {
                                let params = {
                                    uid: this.$store.state.username,
                                    oid: response.openid,
                                };
                                //将openid发送给服务器存储
                                this.$syncUserOpenid(params, response2 => {
                                    this.$log(response2)
                                });
                            }
                            // value.headimgurl;
                            // value.nickname;
                            this.postWxUserData(response.nickname, response.headimgurl);
                        });
                    }
                }
            }

            if(this.$common.pay_from_data_page){
                let loadingToast = Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    duration: 0,
                });
                setTimeout(()=>{
                    this.payDataDetail();
                    this.$common.pay_from_data_page = false;
                    loadingToast.clear();
                }, 1000)
            }
            // // 来自淘宝的数据页面
            // if(this.$common_tb.pay_from_tb_data_page){
            //     let loadingToast = Toast.loading({
            //         message: '加载中...',
            //         forbidClick: true,
            //         duration: 0,
            //     });
            //     setTimeout(()=>{
            //         this.payDataDetail();
            //
            //         loadingToast.clear();
            //     }, 1000)
            // }


            // if(this.phoneNumber){
            //     this.formatPhoneNumber(this.phoneNumber);
            // }
        },

        watch: {
            wx_user_info(value) {
                if (value) {
                    this.$refs.wp_user_banner.head_icon = value.headimgurl;
                    this.$refs.wp_user_banner.user_name = value.nickname;
                    
                }
            },
        },

        methods: {

            initActive(){
                let _active = this.$common.getUrlKey('active');
                if(_active){
                    this.active = Number(_active);
                }
            },

            /**
             * 将微信昵称、微信头像提交给服务器
             */
            postWxUserData(nickName, headimgurl){
                if(!this.$store.state.wx_name || this.$store.state.wx_name === 'null'
                    || !this.$store.state.wx_img || this.$store.state.wx_img === 'null'){
                    let head_url = encodeURIComponent(headimgurl)
                    //发送头像、昵称到服务器存储
                    let params3 = {
                        uid: this.$store.state.username,
                        wx_name: nickName,
                        wx_img: head_url
                    };
                    this.$postWxUserData(params3, response3=>{
                        if(response3 && response3.code === 200){
                            let user = this.$store.state;
                            user.wx_name = params3.wx_name;
                            user.wx_img = params3.wx_img;
                            this.$store.commit('login', user);
                        }
                    })
                }else{
                    this.$log("------------登录信息中已包含微信用户信息-------------")
                }
            },

            clickToAuthTb(){
                let url = this.$common_tb.get_oauth_url + "&state=" + this.$store.state.username;
                this.$log(url)
                window.location.href = url;
            },

            // sendMessageToWechat(){
            //
            //
            //     let params = {
            //         content: "@海燕 \n测试测试"
            //     };
            //     // if(this.phone_number.indexOf("137163214") < 0){
            //     //
            //     // }
            //     this.$sendMessageToWechat(params, response=>{
            //         this.$log(response)
            //     })
            // },

            /**
             * 获取指定手机号下所有的账号信息
             */
            getAccountListByPhone(){
                if(this.phoneNumber && this.phoneNumber !== "0"){
                    let params = {
                        phone: this.phoneNumber
                    };

                    this.$getAccountListByPhone(params, response=>{
                        this.$log(response)
                        // {msg: "成功", code: 200, data: Array(2)}
                        if(response && response.code === 200){
                            this.$common.gloabl_account_list = response.data;

                            if(this.$common.gloabl_account_list && this.$common.gloabl_account_list.length > 0){
                                this.can_change_account = true;
                                if(this.$common.gloabl_account_list.length === 1 && this.$common.gloabl_account_list[0].u_name === this.$store.state.username){
                                    this.can_change_account = false;
                                }
                            }
                        }
                    })
                }
            },

            isTest(){
                let url = window.location.href;
                if(url.indexOf("localhost:") !== -1 || url.indexOf("192.168.") !== -1 || url.indexOf("test.wapg.cn") !== -1){
                    return true;
                }else{
                    return false;
                }
            },

            formatPhoneNumber(phone) {
                if (phone && phone !== "0") {
                    // let start = phone.substring(0, 3);
                    let end = phone.substring(7, 11);
                    // this.$log("start = " + start)
                    // this.$log("end = " + end)

                    return "已绑定[" + "*******" + end + "]";
                }
                return ""
            },

            updatePassword() {
                this.$router.push("update_phone");
            },

            modifyPassword() {
                this.$router.push("modify_password");
            },

            // is_weixn() {
            //     var ua = navigator.userAgent.toLowerCase();
            //     if (ua.match(/MicroMessenger/i).indexOf("micromessenger") !== -1) {
            //         alert("微信中")
            //         return true;
            //     } else {
            //         alert("微信外")
            //         return false;
            //     }
            // },

            reloadPage() {
                window.location.reload();
            },

            payDataDetail() {

                if(!this.isTest()){
                    if(this.$common.is_weixn()){
                        if(!this.wx_user_info){
                            this.$dialog.alert({
                                message: "微信用户信息加载中，请稍后再试。\n\n若长时间无法更新微信微信用户信息，\n请退出重新登录。"
                            });
                            return;
                        }
                    }else{
                        this.$dialog.alert({
                            message: "请关注[万品京选]微信公众号\n'进入京选'\n登录后再进行提款"
                        });
                        return;
                    }
                }

                // this.phoneNumber = "123";//测试
                if (this.phoneNumber && this.phoneNumber !== "0") {
                    this.$router.push('paydata');
                } else {
                    this.$dialog.confirm({
                        message: "请绑定手机号",
                    }).then(() => {
                        this.$router.push("update_phone");
                    }).catch(() => {

                    })
                }
            },

            invite() {
                this.showLoading = true;
                this.loadingText = "邀请海报制作中<br/>请稍后...";
                this.getQrcodeUrl(()=>{

                    if (this.$common.is_weixn()) {
                        if(!this.wx_user_info){
                            this.wx_user_info = {};
                        }
                        // this.wx_user_info = {};
                        if (this.wx_user_info) {
                            let timestamp = "_" + Date.parse(new Date());
                            this.show_share_pop = timestamp;
                        } else {
                            this.$dialog.alert({
                                message: "数据初始化中"
                            })
                        }
                    } else {
                        let timestamp = "_" + Date.parse(new Date());
                        this.show_share_pop = timestamp;
                    }

                    this.showLoading = false;
                })
                // this.sendMessageToWechat();
            },


            /**
             * 获取二维码地址
             */
            getQrcodeUrl(fn){
                if(this.$common.gloabl_qrcode_link){
                    this.qrcodeLink = this.$common.gloabl_qrcode_link;
                    if(fn){
                        fn();
                    }
                }else{
                    let fid = this.$store.state.username;
                    if (fid) {
                        this.$getWxQRUrl(fid, response=> {
                            this.$log(response)
                            if(response && response.url){
                                let shareUrl = response.url;
                                if (shareUrl) {
                                    this.qrcodeLink = shareUrl;
                                    this.$common.gloabl_qrcode_link = shareUrl;

                                    if(fn){
                                        fn();
                                    }
                                }
                            }else{
                                this.showLoading = false;
                                this.$dialog.alert({
                                    message: "邀请海报制作失败，请重试"
                                })
                            }

                        })
                        // this.newLink = this.$common.invite_regist_by_qrcode_url + "?fid=" + this.$store.state.username
                    }
                }
            },

            initWxUserInfo(fn) {
                // this.text = this.$common.getUrlParams();
                let code = this.$common.getUrlKey("code");
                if (code) {
                    //调用接口获取openId   参考文档https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421140842
                    this.getUserInfo(code, response => {
                        fn(response)
                    })
                } else {
                    this.getCodeApi("123")
                }
            },
            getCodeApi(state) {//获取code
                // let urlNow = encodeURIComponent(window.location.href);
                // snsapi_base 不需要用户点同意，直接跳转到授权后的页面，只能用于获取openid，不能获取用户基本信息
                // snsapi_userinfo 会征求用户同意，授权后，可以获取用户基本信息

                let scope = 'snsapi_userinfo';    //snsapi_base  snsapi_userinfo //静默授权 用户无感知

                let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.$config.app_id}&redirect_uri=${this.$config.redirect_url}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;

                this.url = url;
                //
                setTimeout(function () {
                    window.location.replace(url);
                }, 50)
            },
            jump() {
                window.location.replace(this.url);
            },
            getUserInfo(code, fn) {
                if (code) {
                    //地址为https://api.weixin.qq.com/sns/userinfo?access_token=ACCESS_TOKEN&openid=OPENID&lang=zh_CN
                    this.url_2 = `https://api.wapg.cn/jd_union/wechat/user_info?code=${code}&channel=${this.$store.state.username}&app_id=${this.$config.app_id}&app_${this.$config.app_secret}`;
                    let that = this;
                    this.$axios.get(this.url_2)
                        .then((res) => {
                            this.$log(res);
                            that.user_info = res
                            fn(res.data);
                        }).catch((c) => {
                        that.user_info = c;
                    })
                }
            },


            showMiniQrImg(){
                const toast = Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: '获取小程序码...'
                });
                this.getMiniQrImg(qrImgUrl => {
                    toast.clear();
                    ImagePreview({
                        images: [
                            qrImgUrl
                        ],
                        showIndex: false
                    });
                })
            },

            /**
             * 获取小程序二维码图片
             * @param fn
             */
            getMiniQrImg(fn){
                if(this.$common.gloabl_mini_qrcode_link){
                    fn(this.$common.gloabl_mini_qrcode_link)
                }else{
                    let params = {
                        app_id: this.$common.wx_app_id,
                        app_secret: this.$common.wx_app_secret,
                        page: 'pages/login/login_pw/login_pw',
                        scene: "",
                        // scene: this.$store.state.username,
                        width: 1000
                    };
                    this.$getWxAppQrcode(params, response =>{
                        this.$log(response)
                        if(response && response.data){
                            let qr_img_url = response.data;
                            this.$common.gloabl_mini_qrcode_link = qr_img_url;
                            if (qr_img_url) {
                                if(fn){
                                    fn(qr_img_url);
                                }
                            }
                        }else{
                            Dialog.alert({
                                message: "邀请海报制作失败，请重试"
                            })
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .van-cell {
        font-size: 17px;
    }

</style>
